import { Component, signal } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ErrorComponent, TextAreaComponent } from '@group24ag/flowkit';

@Component({
  imports: [
    ErrorComponent,
    FormsModule,
    ReactiveFormsModule,
    TextAreaComponent,
  ],
  selector: 'app-ui-text-areas',
  template: `
    <div>
      <h1 class="heading-title">Text Areas</h1>
      <div class="flex flex-col gap-10">
        <flk-text-area
          [(ngModel)]="value"
          [placeholder]="'Your Description'"
          [resizeDirection]="'horizontal'"
          [label]="'Description'"
          [initialWidth]="'24rem'"
          class="max-w-[75%]" />
        <flk-text-area
          [formControl]="control1"
          [placeholder]="'Your Description'"
          [resizeDirection]="'vertical'"
          [initialHeight]="'200px'"
          [label]="'Description'"
          class="max-h-96 w-96" />
        <flk-text-area
          [formControl]="control2"
          [placeholder]="'Your Description'"
          [resizeDirection]="'both'"
          [label]="'Description'"
          [initialWidth]="'24rem'"
          [initialHeight]="'80px'" />
        <flk-text-area
          [formControl]="control3"
          [placeholder]="'Your Description'"
          [resizeDirection]="'both'"
          [label]="'Description'"
          class="max-h-[500px] max-w-[75%] min-w-96">
          <flk-error>Name is required</flk-error>
        </flk-text-area>
        <flk-text-area
          [formControl]="control4"
          [placeholder]="'Your Description'"
          [resizeDirection]="resize()"
          class="w-96" />
      </div>
    </div>
  `,
})
export class UITextAreasComponent {
  private lI: string =
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.';

  control1 = new FormControl(this.lI);
  control2 = new FormControl({ value: this.lI, disabled: true });
  control3 = new FormControl('', [Validators.required]);
  control4 = new FormControl('');

  value = this.lI;

  resize = signal<'horizontal' | 'vertical' | 'both' | 'none'>('none');
}
